import axios from 'axios';
import { apiConfig } from '@/utils/config';
import { getFingerprint } from './fingerprint';
import { decryptData } from '@/utils/crypto';

// Create an Axios instance
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL || apiConfig.baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor to handle retries
apiClient.interceptors.response.use(
  response => response, // Return the response if successful
  async error => {
    const config = error.config;
    if (!config || !config.retry) return Promise.reject(error);

    config.__retryCount = config.__retryCount || 0;

    if (config.__retryCount >= config.retry) {
      // Reject with the error after exhausting retries
      return Promise.reject(error);
    }

    config.__retryCount += 1;

    // Optional: Add delay between retries
    const delay = new Promise(resolve => setTimeout(resolve, config.retryDelay || 1000));

    await delay;

    // Retry the request
    return apiClient(config);
  }
);

// Centralized methods for HTTP requests
const apiService = {

  async get(endpoint, params = {}, requiresAuth = true, retry = 3, retryDelay = 1000) {
    const config = {
      params,
      retry,
      retryDelay,
      headers: {},
    };
    const deviceId = await getFingerprint();
    config.headers['X-FP-EM'] = deviceId;
    if (requiresAuth) {
      
      const token = decryptData(localStorage.getItem("token"));
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return apiClient.get(endpoint, config);
  },

  async post(endpoint, data, requiresAuth = true, config = {}) {
    config.headers = config.headers || {};
    config.retry = config.retry || 3;
    config.retryDelay = config.retryDelay || 1000;
    const deviceId = await getFingerprint();
    config.headers['X-FP-EM'] = deviceId;

    if (requiresAuth) {
      const token = decryptData(localStorage.getItem("token"));
      
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }
    }

    return apiClient.post(endpoint, data, config);
  },

  async put(endpoint, data, requiresAuth = true, config = {}) {
     config.headers = config.headers || {};
    config.retry = config.retry || 3;
    config.retryDelay = config.retryDelay || 1000;
    const deviceId = await getFingerprint();
    config.headers['X-FP-EM'] = deviceId;
    if (requiresAuth) {
      const token = decryptData(localStorage.getItem("token"));
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
          "Cookie": document.cookie
        };
      }
    }

    return apiClient.put(endpoint, data, config);
  },

  async delete(endpoint, requiresAuth = true, config = {}) {
     config.headers = config.headers || {};
    config.retry = config.retry || 3;
    config.retryDelay = config.retryDelay || 1000;
    const deviceId = await getFingerprint();
    config.headers['X-FP-EM'] = deviceId;
    if (requiresAuth) {
       const token = decryptData(localStorage.getItem("token"));
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
          "Cookie": document.cookie
        };
      }
    }

    return apiClient.delete(endpoint, config);
  },
};

export default apiService;
